import pluralize from 'pluralize';

export function getTitle(alerts) {
  if (alerts.critical) return `You have ${alerts.critical} critical ${pluralize('task', Number(alerts.critical))}!`;
  if (alerts.overdue) return `You have ${alerts.overdue} overdue ${pluralize('task', Number(alerts.overdue))}!`;
  if (alerts.urgent) return `You have ${alerts.urgent} urgent ${pluralize('task', Number(alerts.urgent))}!`;

  return `You have ${alerts.total} ${pluralize('task', Number(alerts.total))} due today`;
}

// Internal helper functions
export function getBadgeType(alerts) {
  if (alerts.overdue || alerts.critical) return 'danger';
  if (alerts.urgent) return 'urgent';
  
  return 'warning';
}
